import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import { calcContainer, calculateHeight, isInPrerenderMode, isUnknownContainer } from '../../utils/gallery';
import { makeEventListener } from '../hooks/eventListener';
export const WixProGalleryWithStructure = WixProGallery => props => {
  const isUnKnownContainer = isUnknownContainer(props.container, props.options);
  const isPrerenderMode = isInPrerenderMode(props.viewMode, isUnKnownContainer);
  const handleNewGalleryStructure = newGalleryStructureData => {
    // TODO when this is ready - take it outside of this file
    const numOfItems = newGalleryStructureData.numOfItems,
      galleryContainer = newGalleryStructureData.container,
      galleryOptions = newGalleryStructureData.options,
      layoutHeight = newGalleryStructureData.layoutHeight,
      isInfinite = newGalleryStructureData.isInfinite,
      isFixedHorizontlaGalleryRatio = newGalleryStructureData.isFixedHorizontlaGalleryRatio,
      updatedHeight = newGalleryStructureData.updatedHeight;
    const setHeightImp = newHeight => {
      if (typeof props.setLayoutHeightImp === 'function') {
        props.setLayoutHeightImp(newHeight);
      }
    };
    // TBD check offsetTop

    calculateHeight({
      viewMode: props.viewMode,
      layoutHeight,
      galleryOptions,
      galleryContainer,
      numOfItems,
      isInfinite,
      isFixedHorizontlaGalleryRatio,
      updatedHeight,
      setHeightImp
    });
  };
  const container = calcContainer(isUnKnownContainer, props.container, props.isMobile);
  const eventsListener = makeEventListener().GALLERY_CHANGE(data => handleNewGalleryStructure(data)).done(props.eventsListener);
  const prerenderStyle = isPrerenderMode ? {
    display: 'none'
  } : {};
  return /*#__PURE__*/React.createElement(WixProGallery, _extends({}, props, {
    container: container,
    eventsListener: eventsListener,
    styles: prerenderStyle,
    isPrerenderMode: isPrerenderMode
  }));
};
//# sourceMappingURL=withStructure.js.map